import "./Candle.css";

export default function Candle() {
  return (
    <div className="holder" style={{transform: 'scale(0.5)',}}>
      <div className="candle">
        <div className="blinking-glow"></div>
        <div className="thread"></div>
        <div className="glow"></div>
        <div className="flame"></div>
      </div>
    </div>
  );
}
